import { Component, OnInit, NgModule, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { startWith } from 'rxjs/operators/startWith';
import Swal from 'sweetalert2';
import { Global } from '../../global';
import { ApiService } from '../../services/api.service';

import {
  Router,
  NavigationStart,
  NavigationEnd,
  ActivatedRoute,
  Event as NavigationEvent
} from "@angular/router";
import { ModalTrocaSenhaComponent } from '../../components/modal-troca-senha/modal-troca-senha.component';



@Component({
  selector: 'app-meus-dados',
  templateUrl: './meus-dados.component.html',
  styleUrls: ['./meus-dados.component.css']
})
export class MeusDadosComponent implements OnInit {

  imgSrc: any = '../../../../assets/img/default.jpg';
  loading = false;
  redefinindo_senha = false;

  currentUser: any = {};
  funcionario: any = {};

  constructor(
    private apiService: ApiService,
    public global: Global,
    public dialog: MatDialog,
    private router: Router
  ) {
    try {
      if (localStorage.getItem("currentUser") == null)
        this.router.navigate(["/login"]);
      this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    } catch (err) {
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
    this.getFuncionario();
  }

  dataFormat(data) {
    return this.global.dateFormater(data);
  }

  mudar_senha() {
    this.redefinindo_senha = true;
  }

  voltar() {
    this.redefinindo_senha = false;
  }

  openDialog(req): void {
    let dialogRef = this.dialog.open(ModalTrocaSenhaComponent, { data: req });
    dialogRef.afterClosed().subscribe(result => {
      //this.router.navigate(["/login"]);
    });
  }

  getFuncionario = () => {
    this.loading = true;
    this.apiService.GetOne("Funcionarios", this.currentUser.uuid).then(
      result => {
        this.funcionario = result;
        console.log(this.funcionario);
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
        this.loading = false;
      }
    );
    this.loading = false;
  }

  formataCPF(cpf) {
    if (cpf != null && cpf != "") {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
  }

  submit() {
    if (this.funcionario.usar_nome_social == false) {
      this.funcionario.nome_social = " ";
    }
    if (this.funcionario.usar_nome_social == true && this.funcionario.nome_social == " " ||
      this.funcionario.usar_nome_social == true && this.funcionario.nome_social == null) {
      this.funcionario.nome_social = " ";
      this.funcionario.usar_nome_social = false;
    }
    this.loading = true;
    console.log(this.funcionario.usar_nome_social)
    this.apiService.Put_current("Funcionarios", this.funcionario).then(
      result => {
        Swal.fire({
          type: 'success',
          title: 'Sucesso!',
          text: 'Seus dados foram atualizados com sucesso'
        });
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/meus-dados/meus-dados.component.ts